/* ================================================== */
/* FAST CLICK → Init
/* ================================================== */

$(function() {

	// Init
	FastClick.attach(document.body);

});